export default __webpack_public_path__ + "static/media/notes.0ff6d600.png";